<template>
	<div>
		<form :id="id ? id : 'vueReactiveForm'" :get="get" :post="post" :paginate="paginate" :onload="onload" :par="par" >
			<slot :prop="prop" :select="select" :data="data" :response="response" ></slot>
			<div v-if="get !== null && this.run == true">
				<div>
					<infinite-loading  @infinite="infiniteHandler" ref="infiniteLoading">
						<span slot="no-more">No hay más datos</span>
						<span slot="spinner">Cargando...</span>
						<span slot="no-results">No hay más datos</span>
					</infinite-loading>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import Axios from 'axios';

export default {
	props: [
	'id',
	'get',
	'post',
	'paginate',
	'onload',
	'par',
	],
	mounted() {
		this.$on('bcRefrescarSelect', function(who, val){
			this.$emit('bcRefrescarChild', who, val);
		});
		this.$on('emitRefreshSelection', function(who, val){
			this.$emit('broadcastRefreshSelection', who, val);
		});
		if(this.$props.onload == 'true') {
			this.run = true;
		}

		const vm = this;
		const elem = $("#"+(this.$props.id ? this.$props.id : 'vueReactiveForm'));		

		elem.submit( function(event) {

			event.preventDefault();

			if (vm.$props.post !== '') {

				const data = elem.serialize();				
				vm.postM(data);

			} else {

				const formData = elem.serializeArray();

				// Obtener campos que son de tipo arreglo (select)
				const arrayFields = formData.reduce((arrFields, obj) => {	

					const key = obj['name'];
					const isArrayField = obj.name.includes('[]');
					const clearedKey = key.replace(/[\[\]']+/g,'');

					if (!arrFields[clearedKey] && isArrayField) {

						arrFields[clearedKey] = [];			

					}

					if (isArrayField) {

						arrFields[clearedKey].push(obj.value);

					}

					return arrFields;

				}, {});			
				vm.params = formData.reduce(
					(acum, e) => ({
						...acum, 
						[e.name]: e.value
					}), 
					{}
					);

				// Sí existen campos de tipo arreglo los añadimos a los parámetros serializados del formulario
				if (!(Object.keys(arrayFields).length === 0 && arrayFields.constructor === Object)) {

					Object.assign(vm.params, arrayFields);
				}

				vm.run = true;
				vm.refresh();

			}
		});
	},
	data() { return {
		prop: {},
		select: {},
		data: [],
		page: 1,
		params: {},
		run: false,
		response: {}
	}},
	methods: {
		postM: function(data) {
			axios.post(this.$props.post, data).then(response => {
				toastr["success"](response.data.message, "Registro creado con éxito");
				$(reactiveCurrentOpenModal).modal('hide');
			}).catch(e => {			
				const mensajeError = (e.response) ? e.response.data.message : 'Ocurrió un problema inesperado';			
				toastr["error"](mensajeError);

			});
		},
		getM: function(url) {
			return new Promise(resolve => {
				setTimeout(() => {
					let filters = {...{page: this.page}, ...this.params};

					if(reactiveCurrentRowSelected != undefined) {
						url = '/' + reactiveCurrentRowSelected;
					}

					Axios.get(url, { params: filters }).then(res => {
						this.response = res.data
						if(this.$props.paginate == 'true') {
							this.data = this.data.concat(res.data.data || []);
							this.page++;
							if(this.page <= res.data.last_page) {
								resolve(true);
							} else {
								resolve(false);
							}
						} else {
							this.data = this.data.concat(res.data);
							resolve(false);
						}
					});
				}, 1000);
			});
		},
		infiniteHandler: async function($state) {
			await this.getM(this.$props.get).then(again => {
				if(again) {
					$state.loaded();
				} else {
					$state.complete();
				}
			});
		},
		refresh: function() {
			if(this.$refs.infiniteLoading) {
				this.data = [];
				this.page = 1;
				this.$refs.infiniteLoading.stateChanger.reset();
			}
		},
		submitForm(url) {
			const form = $("#"+(this.$props.id ? this.$props.id : 'vueReactiveForm'));
			form.submit();
		}
	}
}
</script>
